const RELATIVE_TIME = new Intl.RelativeTimeFormat('en', { numeric: 'auto' })

function prettyLabel(label: string): string {
  if (!label) return label
  return label.charAt(0).toUpperCase() + label.slice(1)
}

/**
 * Human relative age. Avoids raw day dumps like "1319d ago".
 * Optional `nowMs` keeps tests deterministic.
 */
export function formatRelativeTime(iso?: string, nowMs: number = Date.now()): string {
  if (!iso) return ''
  const then = new Date(iso).getTime()
  if (Number.isNaN(then)) return ''
  const diffMs = nowMs - then
  const abs = Math.abs(diffMs)
  const sign = diffMs >= 0 ? -1 : 1
  if (abs < 45_000) return 'Just now'
  if (abs < 3_600_000) {
    return prettyLabel(RELATIVE_TIME.format(sign * Math.max(1, Math.round(abs / 60_000)), 'minute'))
  }
  if (abs < 86_400_000) {
    return prettyLabel(RELATIVE_TIME.format(sign * Math.max(1, Math.round(abs / 3_600_000)), 'hour'))
  }
  const days = abs / 86_400_000
  if (days < 14) {
    return prettyLabel(RELATIVE_TIME.format(sign * Math.round(days), 'day'))
  }
  const weeks = days / 7
  if (weeks < 8) {
    return prettyLabel(RELATIVE_TIME.format(sign * Math.round(weeks), 'week'))
  }
  const months = days / 30.44
  if (months < 18) {
    return prettyLabel(RELATIVE_TIME.format(sign * Math.round(months), 'month'))
  }
  return prettyLabel(RELATIVE_TIME.format(sign * Math.round(days / 365.25), 'year'))
}
